const getPrice = (price)=>{
    if (!price) return;
    return {
        ...price,
        from: !!price?.from,
        value: Number(price?.value)
    };
};
export const productCardPackagesMobileConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { soldOut: soldOutInProps , config ={} , title ='' , subtitle ='' , link ={
        href: ''
    } , image ={
        src: ''
    } , promotion ='' , icon , rating , upside , descriptions =[] , price ={} , isDeal , stars , tripadvisor , ldjson  } = data;
    const soldOut = props.soldOut ?? soldOutInProps;
    const ldjsonScript = ldjson && 'scripts' in ldjson ? ldjson : {
        scripts: [
            ldjson
        ]
    };
    const starsValue = typeof stars === 'number' ? stars : stars?.value;
    const _upside = upside && Array.isArray(upside) ? upside : [
        upside ?? ''
    ];
    return {
        ...data,
        config: {
            ...config,
            deal: isDeal ?? config?.deal,
            icon: !!icon,
            iconName: icon,
            rating: stars ? 'star' : undefined,
            product: config?.type,
            soldOut,
            literals: {
                fromCaption: data.price?.from,
                good: rating?.text,
                veryGood: rating?.text,
                excelent: rating?.text
            }
        },
        title,
        subtitle,
        image,
        link,
        tripadvisor,
        reviews: rating?.value,
        rating: starsValue,
        upside: _upside,
        promotion,
        descriptions: descriptions.flatMap((desc)=>desc?.content ?? '') || [],
        price: getPrice(price),
        ldjson: ldjsonScript
    };
};

//# sourceMappingURL=converter.js.map